import VueRouter from 'vue-router'
import Vue from 'vue'
import Auth from '@/plugins/auth'
import EventBus from '~/plugins/eventbus'
import Consts from '@/consts'

import LoginIndex from '~/components/login/Login.vue'
import SharedTopBar from '~/components/shared/TopBar.vue'
import SharedFooter from '~/components/shared/Footer.vue'
import SharedSidenav from '~/components/shared/Sidenav.vue'

import AdminIndex from '~/components/admin/Index.vue'
import AdminSettingsUsersIndex from '~/components/admin/settings/users/Index.vue'
import AdminSettingsUsersEdit from '~/components/admin/settings/users/Edit.vue'
import AdminSettingsLangsIndex from '~/components/admin/settings/langs/Index.vue'
import AdminSettingsLangsEdit from '~/components/admin/settings/langs/Edit.vue'
import AdminSettingsRdsIndex from '~/components/admin/settings/regional-directorates/Index.vue'
import AdminSettingsRdsEdit from '~/components/admin/settings/regional-directorates/Edit.vue'
import AdminSettingsRegionsIndex from '~/components/admin/settings/regions/Index.vue'
import AdminSettingsRegionsEdit from '~/components/admin/settings/regions/Edit.vue'
import AdminSettingsCyclesEdit from '~/components/admin/settings/cycles/Edit.vue'
import AdminSettingsCyclesIndex from '~/components/admin/settings/cycles/Index.vue'
import AdminSettingsRegimesEdit from '~/components/admin/settings/regimes/Edit.vue'
import AdminSettingsRegimesIndex from '~/components/admin/settings/regimes/Index.vue'
import AdminSettingsAgeGroupsEdit from '~/components/admin/settings/age-groups/Edit.vue'
import AdminSettingsAgeGroupsIndex from '~/components/admin/settings/age-groups/Index.vue'
import AdminSettingsValuesIndex from '~/components/admin/settings/values/Index.vue'
import AdminSchoolsIndex from '~/components/admin/schools/Index.vue'
import AdminSchoolsEdit from '~/components/admin/schools/Edit.vue'
import AdminSchoolsShow from '~/components/admin/schools/Show.vue'
import AdminSchoolsShowInfo from '~/components/admin/schools/ShowInfo.vue'
import AdminSchoolsShowRepresentatives from '~/components/admin/schools/ShowRepresentatives.vue'

import ResetPasswordIndex from '~/components/reset-password/index.vue'
import ResetPasswordVerifyCode from '~/components/reset-password/verify-code.vue'
import ResetPasswordReset from '~/components/reset-password/reset-password.vue'

import RepresentativesIndex from '~/components/representatives/Index.vue'
import RepresentativesShow from '~/components/representatives/Show.vue'

import MessagesIndex from '~/components/messages/Index.vue'
import MessagesSurvey from '~/components/messages/Survey.vue'

import PrivateMessages from '~/components/messages/PrivateMessages.vue'

import SurveysIndex from '~/components/surveys/Index.vue'
import SurveysEdit from '~/components/surveys/Edit.vue'
import SurveysShow from '~/components/surveys/Show.vue'
import SurveysShowInfo from '~/components/surveys/ShowInfo.vue'
import SurveysShowSurvey from '~/components/surveys/ShowSurvey.vue'
import SurveysShowAnswers from '~/components/surveys/ShowAnswers.vue'

import DocumentsIndex from '~/components/documents/Index.vue'

import AbusiveMessagesIndex from '~/components/messages/Abusives.vue'

import ActivationIndex from '~/components/activation/Activation.vue'

import AdminStatsConnections from '~/components/admin/stats/Connections.vue'

import LegalFr from '~/components/legal/fr.vue'

import CirclesIndex from '~/components/circles/Index.vue'
import CirclesEdit from '~/components/circles/Edit.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            name: 'admin-index',
            path: '/admin',
            redirect: '/admin/settings/users',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: AdminIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                admin: true
            },
            children: [
                {
                    name: 'admin-settings-users-index',
                    path: 'settings/users',
                    components: {
                        adminbody: AdminSettingsUsersIndex
                    }
                },
                {
                    name: 'admin-settings-users-edit',
                    path: 'settings/users/:id',
                    components: {
                        adminbody: AdminSettingsUsersEdit
                    }
                },
                {
                    name: 'admin-settings-langs-index',
                    path: 'settings/langs',
                    components: {
                        adminbody: AdminSettingsLangsIndex
                    }
                },
                {
                    name: 'admin-settings-langs-edit',
                    path: 'settings/langs/:id',
                    components: {
                        adminbody: AdminSettingsLangsEdit
                    }
                },
                {
                    name: 'admin-settings-regional-directorates-index',
                    path: 'settings/regional-directorates',
                    components: {
                        adminbody: AdminSettingsRdsIndex
                    }
                },
                {
                    name: 'admin-settings-regional-directorates-edit',
                    path: 'settings/regional-directorates/:id',
                    components: {
                        adminbody: AdminSettingsRdsEdit
                    }
                },
                {
                    name: 'admin-settings-regions-index',
                    path: 'settings/regions',
                    components: {
                        adminbody: AdminSettingsRegionsIndex
                    }
                },
                {
                    name: 'admin-settings-regions-edit',
                    path: 'settings/regions/:id',
                    components: {
                        adminbody: AdminSettingsRegionsEdit
                    }
                },
                {
                    name: 'admin-settings-cycles-index',
                    path: 'settings/cycles',
                    components: {
                        adminbody: AdminSettingsCyclesIndex
                    }
                },
                {
                    name: 'admin-settings-cycles-edit',
                    path: 'settings/cycles/:id',
                    components: {
                        adminbody: AdminSettingsCyclesEdit
                    }
                },
                {
                    name: 'admin-settings-regimes-index',
                    path: 'settings/regimes',
                    components: {
                        adminbody: AdminSettingsRegimesIndex
                    }
                },
                {
                    name: 'admin-settings-regimes-edit',
                    path: 'settings/regimes/:id',
                    components: {
                        adminbody: AdminSettingsRegimesEdit
                    }
                },
                {
                    name: 'admin-settings-age-groups-index',
                    path: 'settings/age-groups',
                    components: {
                        adminbody: AdminSettingsAgeGroupsIndex
                    }
                },
                {
                    name: 'admin-settings-age-groups-edit',
                    path: 'settings/age-groups/:id',
                    components: {
                        adminbody: AdminSettingsAgeGroupsEdit
                    }
                },
                {
                    name: 'admin-settings-values-index',
                    path: 'settings/values',
                    components: {
                        adminbody: AdminSettingsValuesIndex
                    }
                }
            ]
        },
        {
            name: 'login',
            path: '/login',
            components: {
                top: SharedTopBar,
                body: LoginIndex,
                footer: SharedFooter
            },
            meta: {
                auth: false
            }
        },
        {
            name: 'reset-password-index',
            path: '/reset-password',
            components: {
                top: SharedTopBar,
                body: ResetPasswordIndex,
                footer: SharedFooter
            },
            meta: {
                auth: false
            }
        },
        {
            name: 'reset-password-verify-code',
            path: '/reset-password/:id/verify-code',
            components: {
                top: SharedTopBar,
                body: ResetPasswordVerifyCode,
                footer: SharedFooter
            },
            meta: {
                auth: false
            }
        },
        {
            name: 'reset-password-reset',
            path: '/reset-password/:id/reset',
            components: {
                top: SharedTopBar,
                body: ResetPasswordReset,
                footer: SharedFooter
            },
            meta: {
                auth: false
            }
        },
        {
            name: 'admin-schools-index',
            path: '/admin/schools',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: AdminSchoolsIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                admin: true
            },
        },
        {
            name: 'admin-schools-edit',
            path: '/admin/schools/:id/edit',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: AdminSchoolsEdit,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                admin: true
            },
        },
        {
            name: 'admin-schools-show',
            path: '/admin/schools/:id',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: AdminSchoolsShow,
                footer: SharedFooter
            },
            redirect: to => {
                const { params } = to
                return { name: 'admin-schools-show-info', params: { id: params.id } }
            },
            meta: { auth: true, admin: true },
            props: true,
            children: [
                {
                    name: 'admin-schools-show-info',
                    path: 'info',
                    components: { panel: AdminSchoolsShowInfo },
                    meta: { auth: true, tab: 'info', admin: true }
                },
                {
                    name: 'admin-schools-show-representatives',
                    path: 'representatives',
                    components: { panel: AdminSchoolsShowRepresentatives },
                    meta: { auth: true, tab: 'representatives', admin: true }
                }
            ]
        },
        {
            name: 'representatives-index',
            path: '/representatives',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: RepresentativesIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'representatives-show',
            path: '/representatives/:id',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: RepresentativesShow,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'my-wall',
            path: '/my-wall',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: MessagesIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'my-messages',
            path: '/my-messages',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: PrivateMessages,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'my-circle',
            path: '/my-circle',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: MessagesIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'messages-survey',
            path: '/survey/:id',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: MessagesSurvey,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'surveys-index',
            path: '/surveys',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: SurveysIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                national: true
            },
        },
        {
            name: 'surveys-edit',
            path: '/surveys/:id/edit',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: SurveysEdit,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                national: true
            },
        },
        {
            name: 'surveys-show',
            path: '/surveys/:id',
            redirect: '/surveys/:id/info',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: SurveysShow,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                admin: false,
                national: true
            },
            children: [
                {
                    name: 'surveys-show-info',
                    path: 'info',
                    components: {
                        surveybody: SurveysShowInfo
                    }
                },
                {
                    name: 'surveys-show-survey',
                    path: 'survey',
                    components: {
                        surveybody: SurveysShowSurvey
                    }
                },
                {
                    name: 'surveys-show-survey-preview',
                    path: 'survey-preview',
                    components: {
                        surveybody: MessagesSurvey
                    }
                },
                {
                    name: 'surveys-show-answers',
                    path: 'answers',
                    components: {
                        surveybody: SurveysShowAnswers
                    }
                },
            ]
        },
        {
            name: 'documents-index',
            path: '/documents',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: DocumentsIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'abusive-messages-index',
            path: '/abusive-messages',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: AbusiveMessagesIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                admin: true
            },
        },
        {
            name: 'activation',
            path: '/activation/:token',
            components: {
                top: SharedTopBar,
                body: ActivationIndex,
                footer: SharedFooter
            },
            meta: {
                auth: false
            }
        },
        {
            name: 'admin-stats-connections',
            path: '/admin/stats/connections',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: AdminStatsConnections,
                footer: SharedFooter
            },
            meta: {
                auth: true,
                admin: true
            },
        },
        {
            name: 'legal-notice',
            path: '/legal-notice',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: LegalFr,
                footer: SharedFooter
            },
            meta: {
                auth: false
            }
        },
        {
            name: 'circles-index',
            path: '/circles',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: CirclesIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'circles-show',
            path: '/circles/:id',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: MessagesIndex,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
        {
            name: 'circles-edit',
            path: '/circles/:id/edit',
            components: {
                top: SharedTopBar,
                sidenav: SharedSidenav,
                body: CirclesEdit,
                footer: SharedFooter
            },
            meta: {
                auth: true
            },
        },
    ]
})


router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        router.push({ name: 'login' })
    }

    if (to.name && (to.matched[0].meta.auth && !Auth.authenticated)) {
        // This route requires an authentication, and user isn't
        // authenticated. Redirect him to the login page.
        EventBus.$emit('addDestination')
        router.push('/login?redirect=' + window.location.pathname + window.location.search)
    }
    else if (to.name && (to.matched[0].meta.admin && !Auth.user.is_admin)) {
        router.push({ name: 'my-wall' })
    }
    else if (to.name && (to.matched[0].meta.national && (!Auth.user.is_admin && Auth.user.level != Consts.MINISTRY && Auth.user.level != Consts.NATIONAL))) {
        router.push({ name: 'my-wall' })
    }
    else {
        next()
    }
})

export default router